import TextWinds from '../common/TextWinds';
import { numberWithCommas } from '../../api/utils/format/numbers';
import { OptionDetail, OrderItem, VariantDetail } from '../../constants/types';

interface OptionListProps {
  orderItem: OrderItem;
  type: 'variant_details' | 'option_details';
}
export const OptionList = ({ orderItem, type }: OptionListProps) => {
  const list =
    type === 'variant_details'
      ? orderItem.discount_info.variant_details
      : orderItem.discount_info.option_details;

  const getOptionPrice = (variant: VariantDetail | OptionDetail) => {
    if (type === 'variant_details') {
      return (
        orderItem.discount_info.current_price +
        (variant as VariantDetail).additional_price
      );
    } else {
      return (variant as OptionDetail).origin_price;
    }
  };

  return (
    <div>
      <TextWinds type="content_body2">{orderItem.product.name}</TextWinds>
      {list.map((variant, key) => (
        <OptionItem
          key={key}
          name={variant.variant_name}
          optionPrice={getOptionPrice(variant)}
          quantity={variant.quantity}
        />
      ))}
      <OptionTotal orderItem={orderItem} />
    </div>
  );
};

interface OptionItemProps {
  name: string;
  optionPrice: number;
  quantity: number;
}

export const OptionItem = ({
  name,
  optionPrice,
  quantity,
}: OptionItemProps) => {
  return (
    <div className="ml-1 flex items-center gap-y-1 border-l-2 border-gray2 pl-2 text-sm text-gray7">
      <TextWinds type="caption1">{name}</TextWinds>
      <div className="ml-1 text-xs">
        ({numberWithCommas(optionPrice)}원 * {quantity} 개 ={' '}
        {numberWithCommas(optionPrice * quantity)}원 )
      </div>
    </div>
  );
};

export const OptionTotal = ({ orderItem }: { orderItem: OrderItem }) => {
  return (
    <div className="flex items-end gap-x-1">
      <TextWinds type="content_body1">
        {numberWithCommas(orderItem.discount_info.final_total)} 원
      </TextWinds>

      {orderItem.discount_info.total_discount > 0 && (
        <div className="text-base text-gray7 line-through">
          {numberWithCommas(orderItem.discount_info.origin_total)}원
        </div>
      )}
    </div>
  );
};
